import { computed, ref } from 'vue'

const THEME_KEY = 'ralph-web-theme-v2'
const DARK_THEME = 'dark'
const LIGHT_THEME = 'light'

const currentTheme = ref(DARK_THEME)

function isInIframe() {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}

function normalizeTheme(theme) {
  return theme === LIGHT_THEME ? LIGHT_THEME : DARK_THEME
}

function updateThemeColorMeta(theme) {
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) {
    meta.setAttribute('content', theme === DARK_THEME ? '#121212' : '#1B6F7C')
  }
}

function notifyParent(theme) {
  if (!isInIframe()) return
  try {
    window.parent.postMessage({
      type: 'theme-changed',
      source: 'ab-bet-iframe',
      theme,
    }, '*')
  } catch {
    // parent pode estar em outro origem
  }
}

export function useTheme() {
  const applyTheme = (theme, { persist = true, notify = true } = {}) => {
    const next = normalizeTheme(theme)
    const root = document.documentElement
    root.classList.toggle('dark-theme', next === DARK_THEME)
    root.classList.toggle('light-theme', next !== DARK_THEME)
    currentTheme.value = next
    updateThemeColorMeta(next)

    if (persist) {
      try {
        localStorage.setItem(THEME_KEY, next)
      } catch {
        // storage pode estar bloqueado no iframe
      }
    }

    if (notify) {
      notifyParent(next)
    }
  }

  const toggleTheme = () => {
    applyTheme(currentTheme.value === DARK_THEME ? LIGHT_THEME : DARK_THEME)
  }

  const initTheme = () => {
    let theme = DARK_THEME

    try {
      const fromUrl = new URLSearchParams(window.location.search).get('theme')
      if (fromUrl === DARK_THEME || fromUrl === LIGHT_THEME) {
        theme = fromUrl
      } else {
        const saved = localStorage.getItem(THEME_KEY)
        if (saved === DARK_THEME || saved === LIGHT_THEME) {
          theme = saved
        }
      }
    } catch {
      theme = DARK_THEME
    }

    applyTheme(theme, { notify: isInIframe() })
  }

  const isDark = computed(() => currentTheme.value === DARK_THEME)

  return {
    currentTheme,
    toggleTheme,
    initTheme,
    getTheme: () => currentTheme.value,
    isDark,
    applyTheme,
  }
}
